export default {
  $_veeValidate: {
    name() {
      return this.label
    },
    value() {
      return this.value
    },
  },
  props: {
    value: {
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    scope: {
      type: String,
      default: '',
    },
    errorsBag: {
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    selected: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      },
    },
  },
  data() {
    return {
      sugestoes: [],
      isLoading: false,
      solicitouFoco: false,
      erroConexao: false,
    }
  },
  beforeMount() {
    this.carregaTudo()
  },
  watch: {
    isLoading: function (val) {
      if (!val && this.solicitouFoco) {
        this.focar()
      }
    },
  },
  methods: {
    focar() {
      this.solicitouFoco = true
      if (!this.isLoading) {
        this.solicitouFoco = false
        setTimeout(() => {
          if (this.$refs.sug.$children[0].$el.children[0].children[0]) {
            this.$refs.sug.$children[0].$el.children[0].children[0].focus()
          }
        }, 1)
      }
    },
    habilitarCampo() {
      if (this.disabled) {
        return true
      }

      return this.isLoading
    },
  },
}
